import { render, staticRenderFns } from "./AddRemotePlugin.vue?vue&type=template&id=56359905&"
import script from "./AddRemotePlugin.vue?vue&type=script&lang=js&"
export * from "./AddRemotePlugin.vue?vue&type=script&lang=js&"
import style0 from "./AddRemotePlugin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports